import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { AlertTriangle } from 'lucide-react';

const InvestigationalDisclaimer = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gray-100 border-t border-gray-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-start space-x-3">
          <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" />
          <p className="text-xs text-gray-600 leading-relaxed">
            {t(
              'INVESTIGATIONAL PRODUCTS: All Metasigna conjugates are investigational and not approved for human use. No therapeutic claims are made. Forward-looking statements are subject to scientific, regulatory, and funding uncertainties. Actual results may differ. This content is for informational purposes only and does not constitute medical advice.',
              'PRODUCTOS INVESTIGACIONALES: Todos los conjugados de Metasigna son investigacionales y no están aprobados para uso humano. No se realizan claims terapéuticos. Las declaraciones prospectivas están sujetas a incertidumbres científicas, regulatorias y de financiamiento. Los resultados reales pueden diferir. Este contenido es solo informativo y no constituye consejo médico.'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvestigationalDisclaimer;
